// Modules
import React from "react";

// Styles
import "./MvSpinner.sass";

// Components
import ToolTip from "../ToolTip";
import MvIcon from "Generic/MvIcon";
import MvSelect from "../MvSelect";

type MvSpinnerState = {
  open: boolean,
  text: string,
  showSoftError: boolean
};
type Tip = {
  label:string;
  desc:string;
};
type Props ={
  value: number;
  disabled: boolean;
  items: any[];
  onChange: (e: any) => void;
  label: string;
}
class MvSpinner extends React.Component<Props, MvSpinnerState> {
  constructor(props:Props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.handleText = this.handleText.bind(this);
    this.clear = this.clear.bind(this);
    this.drawResult = this.drawResult.bind(this);
    this.state = {
      text: "",
      open: false,
      showSoftError: false
    };
  }
  onChange(e:any) {
    let event = {
      target: {
        type: "spinner",
        value: e.target.value
      }
    };
    this.props.onChange(event);
  }

  handleText(e:any) {
    let value = e.target.value;
    if (!isNaN(value)) {
      value = value.replace(/^0+/, '');
      value = value.trim();
      this.onChange(value);
    }
  }

  clear() {
    this.setState({
      open: true
    });
  }

  drawResult() {
    this.setState({
      open: false,
      showSoftError: false
    });
  }

  render() {
    return <MvSelect
              label={this.props.label}
              items={this.props.items}
              value={`${this.props.value}`}
              name=""
              onChange={this.onChange}
            />

  }
}
export default MvSpinner;
